import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CustomCmsBannerComponent } from '@promo/const';
import { CmsComponentData } from '@spartacus/storefront';

@Component({
  selector: 'sd-titled-banner',
  templateUrl: './titled-banner.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SdTitledBannerComponent {
  constructor(public component: CmsComponentData<CustomCmsBannerComponent>) {}
}
